// extracted by mini-css-extract-plugin
module.exports = {"blocks":"Make1099What_blocks__V_gJA","post-description":"Make1099What_post-description__8nvmX"};